/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {
  Footer,
  PageFooterWrapper,
  Page,
  PageHeaderWrapper,
  helixLight as theme,
  PageContentWrapper
} from '@signanthealth/modular-ui';
import { ScopedCssBaseline, ThemeProvider } from '@mui/material';
import has from 'lodash/has';
import CHeader from '../header/header.container';
import Loading from '../../loading/loading.component';
import Notification from '../../common/notification/notification.component';
import ModalRootContainer from '../../modalRoot/modal.root.container';
import TcBreadcrumbContainer from '../../breadcrumb/tc.breadcrumb.container';
import { SELECTED_SPONSOR, UAT_MESSAGE, EXIT_TEST_COPY } from '../../../constants/common';
import { APP_NAME } from '../../../const';
import Banner from '../banner/banner.component';
import StudyInformationService from '../../../components/studies/details/study.information.service';
import CExportArchiveWithProgressDisplay from '../../export-archive-with-progress-display/export-archive-status.container';
import { IdPortalMigrationModal } from 'tc-client-common';
import { getCookie, setCookie } from '../../../utils/helpers';
import RequestService from '../../../service/requestService';

class Content extends React.Component {
  constructor(props) {
    super(props);
    this.showParticipantArchiveStatus = this.showParticipantArchiveStatus.bind(this);
    this.fetchAcsEligibilityStatus = this.fetchAcsEligibilityStatus.bind(this);
    this.fetchAcsEligibilityStatus();

    this.state = {
      headerHeight: 64
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (document.querySelector('header')) {
      this.setState({ headerHeight: document.querySelector('header').getBoundingClientRect().height });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { user, selectTenantAndSetCookie, selectedSponsor, dispatchSelectSponsorModal } = nextProps;

    let isAuth = has(user, 'username'),
      diffSponsor = false;

    if (!this.props.selectedSponsor && selectedSponsor) {
      if (isAuth) {
        this.props.fetchAssignments(user.userId, selectedSponsor.databasename);
      }
      diffSponsor = true;
    } else if (this.props.selectedSponsor && selectedSponsor) {
      diffSponsor = this.props.selectedSponsor.databasename !== selectedSponsor.databasename;
    }

    /**
     * set sponsor or open modal
     * if user is authenticated AND if (selected sponsor is NULL OR different from previous selected sponsor)
     */
    if (isAuth && (!selectedSponsor || diffSponsor)) {
      let items = [];
      let allocations = user.allocations.filter((a) => {
        if (items[a.databasename]) return false;
        items[a.databasename] = true;
        return true;
      });
      if (allocations.length === 1) {
        const sponsor = allocations[0];
        sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(sponsor));
        selectTenantAndSetCookie(sponsor);
      } else {
        if (sessionStorage.getItem(SELECTED_SPONSOR)) {
          let sponsorOnSession = JSON.parse(sessionStorage.getItem(SELECTED_SPONSOR));
          if (!selectedSponsor) {
            selectTenantAndSetCookie(sponsorOnSession);
          }
        } else {
          dispatchSelectSponsorModal();
        }
      }
    }
  }

  showParticipantArchiveStatus() {
    if (this.props.userAssignment) {
      return this.props.userAssignment.find(
        (assignment) =>
          assignment.canViewPhi &&
          (assignment.userRole.roleName === 'INVESTIGATOR' || assignment.userRole.roleName === 'SITE_USER')
      );
    } else {
      return false;
    }
  }

  fetchAcsEligibilityStatus() {
    RequestService.getAcsEligibilityStatus()
      .then((response) => {
        const idPortalMigration = response.data;
        this.props.updateIdPortalMigrationStatus(response.data);
        if (idPortalMigration) {
          if (
            idPortalMigration.nextStep?.action === 'SHOW_POPUP' ||
            idPortalMigration?.nextStep?.action === 'SHOW_POPUP_FORCED'
          ) {
            const isIdPortalCookie = getCookie('tc-idportal-migration');
            if (!isIdPortalCookie) {
              this.props.showMigrationModal();
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const {
      children,
      selectedSponsor,
      user,
      error,
      selectSponsorError,
      location,
      fetchingUserDetails,
      isFetching,
      isMigrationModalOpen,
      hideMigrationModal,
      idPortalMigration,
      showMigrationSuccessModal,
      hideMigrationSuccessModal,
      showMigrationErrorModal,
      hideMigrationErrorModal,
      isMigrationModalSuccessOpen,
      isMigrationModalErrorOpen,
      logoutUrl,
      signOut
    } = this.props;
    let body = children;
    let banner;
    let showBanner = selectedSponsor && selectedSponsor.type === 'UAT';
    let tenantName = selectedSponsor && selectedSponsor.tenantName;
    let userAllocations = user && user.allocations;
    let showButton = showBanner && StudyInformationService.getProductionTenantForUAT(tenantName, userAllocations);
    const isIdPortalCookie = getCookie('tc-idportal-migration');
    if (showBanner) {
      const tenantDatabaseName = selectedSponsor.sponsorname;
      const allocations = user && user.allocations;
      let tenant =
        tenantDatabaseName && StudyInformationService.getProductionTenantForUAT(tenantDatabaseName, allocations);
      showButton = !!(showButton && tenant);
      banner = (
        <Banner
          label={UAT_MESSAGE}
          showActionButton={showButton}
          buttonAction={() => {
            this.props.selectTenantAndSetCookie(tenant);
            sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(tenant));
            this.props.history.replace('');
          }}
          buttonLabel={EXIT_TEST_COPY}
        />
      );
    }
    const migrationModalApi = {
      className: 'idportal-migration-modal',
      showSkip: idPortalMigration?.nextStep?.action === 'SHOW_POPUP',
      closeId: 'skip-btn',
      successId: 'register-btn',
      close: () => {
        hideMigrationModal();
        setCookie('tc-idportal-migration', '', 1);
      },
      success: () => {
        RequestService.postAcsMigrate()
          .then(() => {
            showMigrationSuccessModal();
            hideMigrationModal();
          })
          .catch((err) => {
            console.error(err);
            showMigrationErrorModal();
            hideMigrationModal();
          });
      },
      endDate: idPortalMigration?.validUntil,
      modalType: 'MIGRATE_USERS_MODAL'
    };

    const migrationModalSuccessApi = {
      className: 'idportal-migration-modal',
      successId: 'logout-btn',
      success: () => {
        hideMigrationSuccessModal();
        signOut(logoutUrl);
      },
      modalType: 'MIGRATE_USERS_MODAL_SUCCESS'
    };

    const migrationModalErrorApi = {
      className: 'idportal-migration-modal',
      closeId: 'try-again-btn',
      successId: 'close-btn',
      close: () => {
        hideMigrationErrorModal();
        RequestService.postAcsMigrate()
          .then(() => {
            showMigrationSuccessModal();
          })
          .catch((err) => {
            console.error(err);
            showMigrationErrorModal();
          });
      },
      success: () => {
        hideMigrationErrorModal();
        setCookie('tc-idportal-migration', '', 1);
      },
      modalType: 'MIGRATE_USERS_MODAL_ERROR'
    };
    if (error) {
      body = <Notification type="error" data={error} />;
    } else if (selectSponsorError) {
      body = <Notification type="error" data={selectSponsorError} />;
    } else {
      if (!user) {
        return <Loading />;
      } else if (!selectedSponsor) {
        return <ModalRootContainer />;
      }
    }

    const { headerHeight } = this.state;
    const mainContentMarginTop = headerHeight - 64 + (showBanner ? 38 : 0); // initial header height is 64px and test banner is 38px

    return fetchingUserDetails || isFetching ? (
      <Loading />
    ) : (
      <>
        {banner}
        <Page className={`modularpage-container ${showBanner && 'uat'}`}>
          <ThemeProvider theme={theme}>
            <ScopedCssBaseline>
              <PageHeaderWrapper className={`modularheader-container ${showBanner && 'uat'}`}>
                <CHeader location={location} />
              </PageHeaderWrapper>
            </ScopedCssBaseline>
          </ThemeProvider>
          <PageContentWrapper>
            <div
              className="layout-ref crf"
              id="content-component-wrapper"
              style={{ marginTop: `${mainContentMarginTop}px` }}
            >
              {this.showParticipantArchiveStatus() && <CExportArchiveWithProgressDisplay />}
              <div className="layout-class">
                <div className="layout-content">
                  <TcBreadcrumbContainer />
                  {isMigrationModalOpen && !isIdPortalCookie && <IdPortalMigrationModal modalApi={migrationModalApi} />}
                  {isMigrationModalSuccessOpen && <IdPortalMigrationModal modalApi={migrationModalSuccessApi} />}
                  {isMigrationModalErrorOpen && <IdPortalMigrationModal modalApi={migrationModalErrorApi} />}
                  {body}
                </div>
              </div>
              <ModalRootContainer />
            </div>
          </PageContentWrapper>
          <ThemeProvider theme={theme}>
            <ScopedCssBaseline>
              <PageFooterWrapper>
                <Footer appName={APP_NAME} />
              </PageFooterWrapper>
            </ScopedCssBaseline>
          </ThemeProvider>
        </Page>
      </>
    );
  }
}

Content.propTypes = {
  user: PropTypes.object,
  error: PropTypes.object,
  selectedSponsor: PropTypes.object,
  children: PropTypes.node,
  selectSponsor: PropTypes.func,
  dispatchSelectSponsorModal: PropTypes.func,
  selectSponsorError: PropTypes.object,
  location: PropTypes.object,
  fetchAssignments: PropTypes.func,
  userAssignment: PropTypes.array,
  isFetching: PropTypes.bool,
  fetchingUserDetails: PropTypes.bool,
  history: PropTypes.object,
  selectTenantAndSetCookie: PropTypes.func,
  idPortalMigration: PropTypes.object
};

Content.contextTypes = {
  router: PropTypes.object.isRequired
};

export default Content;
